import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {ProviderTenantSelectionService} from '../services/provider-tenant-selection.service';

export const PROVIDER_TENANT_HEADER = 'X-Tenant-Id';

export const providerTenantInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.includes('/api/')) {
    return next(req);
  }
  const selectedTenantId = inject(ProviderTenantSelectionService).getSelectedTenantId();
  return next(
    selectedTenantId ? req.clone({setHeaders: {[PROVIDER_TENANT_HEADER]: selectedTenantId}}) : req,
  );
};
